module.exports = __webpack_public_path__ + "img/confluence-blue.6153806b.svg";